/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unescaped-entities */
import { FunctionComponent } from 'react';
import { NewAboutPageConfigs } from '../../../services/partnerUser.service';
import { CompanyCDN } from '../../../utils/url';
import styles from './HowToReturn.module.sass';

const HowToReturn: FunctionComponent<NewAboutPageConfigs> = ({
    returnToSeel,
    shopDomain,
    returnWindow,
}) => {
    return (
        <div className={styles.container}>
            {shopDomain !== 'holythrift.com' && (
                <div className={styles.leftImage}>
                    <img
                        style={{
                            width: '100%',
                        }}
                        src={CompanyCDN.url('/assets/images/about-ra/return-to-merchant.png')}
                        alt="illustration"
                    />
                </div>
            )}

            <div className={styles.rightContent}>
                <div className={styles.title}>How to return</div>
                <ul className={styles.contentList}>
                    {returnToSeel ? (
                        <>
                            <li>
                                Report your return within <span>{returnWindow}</span> days of
                                delivery through the{' '}
                                <a
                                    rel="noreferrer"
                                    target="_blank"
                                    href="https://resolve.seel.com/"
                                >
                                    Seel Resolution Center
                                </a>
                                . Log in with your email and order number or coverage ID from your
                                confirmation email.
                            </li>
                            <li>
                                Select the item(s) you wish to return. Choose your preferred refund
                                method and return shipping option.
                            </li>
                            <li>
                                Follow the instructions provided to ship your return within{' '}
                                <span>{returnWindow}</span> days of delivery. Once received and
                                inspected for eligibility, your refund will be processed.
                            </li>
                        </>
                    ) : shopDomain === 'holythrift.com' ? (
                        <>
                            <li>
                                Email us at{' '}
                                <a href="mailto:team@holythrift.com">team@holythrift.com</a> with
                                the first and last name you used at checkout and the item you want
                                to return. We will create a return label for you that is paid by us.
                            </li>
                            <li>
                                Once you ship it back and we receive the item in its original
                                condition we will issue a full refund as long as the return falls
                                within the 30 day window from which it was delivered. If you take
                                longer than 30 days to initiate this process the item is final sale.
                            </li>
                        </>
                    ) : (
                        <>
                            <li>
                                Check the merchant's return policy on <span>{shopDomain}</span>.
                                Report your return to the merchant within{' '}
                                <span>{returnWindow}</span> days of delivery. Follow all return
                                instructions provided.
                            </li>
                            <li>
                                Once the merchant approves your return request, you will receive
                                your refund.
                            </li>
                        </>
                    )}
                </ul>
                {returnToSeel && (
                    <div className={styles.tip}>
                        <div className={styles.tipMark}>*</div>
                        <p className={styles.tipText}>
                            Return shipping and any applicable transaction fees will be deducted
                            from your refund amount.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};
export default HowToReturn;
